export enum Service {
  GOOGLE = "google",
  GOOGLE_DRIVE = "driveconnector",
  MICROSOFT = "microsoft",
  ZOOM = "zoom",
  SLACK = "slack",
  ZOOMINFO = "zoominfo",
  PANDADOC = "esignconnector.pandadoc"
}

export const ACCOUNT_SERVICES = [
  Service.ZOOM,
  Service.SLACK,
  Service.ZOOMINFO,
  Service.PANDADOC
];

export const REGISTER_SERVICES = ["mail", "calendar", "meet"];
